import { StyledContainer  } from "../components/styles/Container.styled";

const NotFound = () => {
  return (
    <>
      <StyledContainer >
        <h2>Page Not Found</h2>
      </StyledContainer >
    </>
  );
};

export default NotFound;
